import { Cross1Icon, InfoCircledIcon } from '@radix-ui/react-icons'
import { TooltipWrapper } from 'components/TooltipWrapper'
import { useKestrelViewerContext } from 'features/kestrelViewer'
import { ViewToggle } from 'features/kestrelViewer/ui/tools/ViewToggle'
import { RotateCw } from 'lucide-react'
import React, { useState } from 'react'
import styled from 'styled-components'

const ToolbarContainer = styled.div`
  display: flex;
  flex-direction: row;
  position: absolute;
  right: 1.5rem;
  top: 1.5rem;
  z-index: 10;
  button {
    all: unset;
  }
  display: flex;
  justify-items: center;

  button {
    all: unset;
  }
`

interface PhotoReelToolbarProps {
  onRotateClockwise?: () => void
}

export const PhotoReelToolbar: React.FC<PhotoReelToolbarProps> = ({
  onRotateClockwise,
}) => {
  const { setSelectedPhoto } = useKestrelViewerContext()
  const [infoVisible, setInfoVisible] = useState(false)

  const handleInfoClick = () => {
    setInfoVisible(!infoVisible)
  }

  const handleCrossClick = () => {
    // Close the modal
    setSelectedPhoto(null)
  }

  return (
    <ToolbarContainer>
      <TooltipWrapper
        side={'bottom'}
        offset={5}
        label={'Scroll to zoom, and click and drag to pan'}>
        <ViewToggle onClick={handleInfoClick}>
          <InfoCircledIcon />
        </ViewToggle>
      </TooltipWrapper>
      {onRotateClockwise && (
        <TooltipWrapper
          side={'bottom'}
          offset={5}
          label={'Rotate image clockwise'}>
          <ViewToggle onClick={onRotateClockwise}>
            <RotateCw size={15} />
          </ViewToggle>
        </TooltipWrapper>
      )}
      <ViewToggle onClick={handleCrossClick}>
        <Cross1Icon />
      </ViewToggle>
    </ToolbarContainer>
  )
}
